var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogContainer',{attrs:{"showDialog":_vm.showDialog,"isLoading":_vm.isLoading,"type":"confirmation","toolbarActions":[
    {
      text: _vm.submitButtonText,
      icon: _vm.submitButtonIcon,
      buttonColor: _vm.submitButtonColor,
      emitEvent: 'onSubmitClicked',
      showIsLoading: true,
    },
    {
      text: _vm.cancelButtonText,
      depressed: true,
      isVisibleFunc: () => !!_vm.showCancelButton,
      emitEvent: 'onCancelClicked',
    },
  ]},on:{"onCancelClicked":function($event){return _vm.$emit('onCancelClicked')},"onSubmitClicked":function($event){return _vm.$emit('onSubmitClicked')}}},[_c('v-container',{attrs:{"pa-0":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }